import {Source, Layer  } from 'react-map-gl';
const BeamLayer=({point1,point2})=>{
const lineData = {
  type: "Feature",
  properties: {},
  geometry: {
      type: "LineString",
      coordinates: [
          point1,
          point2
      ]
  }
};
const pointData = {
  type: "Feature",
  properties: {},
  geometry: {
      type: "Point",
      coordinates: point1
  }
};
    return <>
    <Source id="beam-point" type="geojson" data={pointData}>
      <Layer id={'beam-point'}
        type={'circle'}
        source={'beam-point'}
        paint={{
          'circle-radius': 6,
          'circle-color': '#333',
          'circle-stroke-width': 2,
          'circle-stroke-color': 'white'
        }}
      />
    </Source>
    <Source id="beam-layer" type="geojson" data={lineData}>
      <Layer id={'beam-layer'}
        type={'line'}
        source={'beam-layer'}
        layout={{
          'line-join': 'round',
          'line-cap': 'round'
        }}
        paint={{
          'line-color': 'red',
          'line-width': 2
        }}
      />
    </Source>
    </>
}

export default BeamLayer